import { useLocation } from 'react-router'
import { type SCREENS } from '../../services/Analytics/Analytics'
import useHomePageAnalytics from './useHomePageAnalytics'
import useHomePageCta from './useHomePageCta'

type Props = {
  screenName: (typeof SCREENS)[keyof typeof SCREENS]
  eventProperties?: Record<string, unknown>
  ctaClickUrl: string
  ctaClickSearchParams?: Record<string, string>
  skipWhoForOnboardingStep?: boolean
}

export default function useHomePage({
  screenName,
  eventProperties = {},
  ctaClickUrl,
  ctaClickSearchParams,
  skipWhoForOnboardingStep = false,
}: Props): {
  onMainCtaClick: () => void
} {
  const location = useLocation()
  const { trackMainCta } = useHomePageAnalytics({ screenName, eventProperties })
  const { navigateToCta } = useHomePageCta()

  const onMainCtaClick = () => {
    trackMainCta()

    const search =
      ctaClickSearchParams &&
      new URLSearchParams(ctaClickSearchParams).toString()

    navigateToCta({
      url: search ? `${ctaClickUrl}?${search}` : ctaClickUrl,
      navOptions: { state: { source: location?.state?.source || screenName } },
      quizNavOptions: { state: { skipWhoForOnboardingStep } },
    })
  }

  return {
    onMainCtaClick,
  }
}
